import { Breadcrumb, Col, Row } from "react-bootstrap"
import { LinkContainer } from "react-router-bootstrap"
import {
  LicenseStatus,
  SortOrder,
  now,
  toTimestamp,
  REGIONS,
  REGION_MAPPING,
  COUNTRIES,
  getCountryNameForCode,
  RegionType,
} from "raml-lib"
import dayjs from "dayjs"
import { CheckingSiteLicenseTable } from "../components/reports/CheckingSiteLicenseTable"
import Select, { ActionMeta } from "react-select"
import { useState } from "react"

export function ReportCheckLicensePage() {
  const [countries, setCountries] = useState<string[] | []>([])
  const [region, setRegion] = useState<
    RegionType.US | RegionType.CA | RegionType.ROW | RegionType.ALL
  >(RegionType.ALL)
  const passed = now()
  const approaching = toTimestamp(dayjs().add(60, "days").toDate())
  const timelyRenewalsApproaching = toTimestamp(
    dayjs().add(60, "days").toDate()
  )

  const setFilteredCountries = (values: string[]) => {
    setCountries(values.filter((v) => v !== "ROW"))
  }

  const regionOptions = REGIONS.map((r) => ({
    value: r,
    label: `${REGION_MAPPING[r]}`,
  }))

  const countryOptions = COUNTRIES.map((r) => ({
    value: r,
    label: `${getCountryNameForCode(r)} (${r})` ?? r,
  }))

  const combinedOptions = [...regionOptions, ...countryOptions]

  type filterOption = {
    label: string
    value: RegionType | string
  }

  const onChange = (
    option: readonly filterOption[],
    actionMeta: ActionMeta<filterOption>
  ) => {
    if (option.some((opt) => opt.value === "ROW")) {
      setRegion(RegionType.ROW)
    } else {
      setRegion(RegionType.ALL)
    }
    // @ts-ignore
    setFilteredCountries(option.map((i) => i.value))
  }

  return (
    <>
      <Breadcrumb>
        <LinkContainer to="/">
          <Breadcrumb.Item>Home</Breadcrumb.Item>
        </LinkContainer>
        <Breadcrumb.Item>Reports</Breadcrumb.Item>
        <Breadcrumb.Item active>Check Licenses</Breadcrumb.Item>
      </Breadcrumb>
      <h1>Check Licenses</h1>
      <p>
        On this page you can view licenses which are approaching or past their
        check date.
      </p>

      <Row>
        <Col md={8}>
          <></>
        </Col>
        <Col md={4}>
          <Select
            placeholder="Select countries"
            // @ts-ignore
            options={combinedOptions}
            onChange={onChange}
            isMulti
          />
        </Col>
      </Row>

      <h2>Approaching check</h2>
      <CheckingSiteLicenseTable
        after={passed}
        before={approaching}
        status={LicenseStatus.ACTIVE}
        region={region}
        countries={countries.join(",")}
        order={SortOrder.ASC}
      />

      <h2>Check date passed</h2>
      <CheckingSiteLicenseTable
        before={passed}
        status={LicenseStatus.ACTIVE}
        region={region}
        countries={countries.join(",")}
        order={SortOrder.DESC}
      />

      <h2>Timely renewals approaching check</h2>
      <CheckingSiteLicenseTable
        after={passed}
        before={timelyRenewalsApproaching}
        status={LicenseStatus.TIMELY_RENEWAL}
        order={SortOrder.ASC}
        region={region}
        countries={countries.join(",")}
      />

      <h2>Timely renewals check date passed</h2>
      <CheckingSiteLicenseTable
        before={passed}
        status={LicenseStatus.TIMELY_RENEWAL}
        order={SortOrder.DESC}
        region={region}
        countries={countries.join(",")}
      />
    </>
  )
}
